import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { merchantTerminalService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type UseBoardAriseMerchantMutationProps = {
	merchantDbaName: string | undefined;
	onSuccess?: Function;
	onError?: Function;
};

const useBoardAriseMerchantMutation = ({
	merchantDbaName,
	onSuccess,
	onError,
}: UseBoardAriseMerchantMutationProps) => {
	const dispatch = useDispatch();

	return useMutation(
		({ merchantId }: { merchantId: string }) => {
			return merchantTerminalService.ariseMerchantBoarding(merchantId);
		},
		{
			onSuccess(result) {
				onSuccess?.(result);
				dispatch(
					uiActions.showSuccessNotification({
						title: `Success! ${
							merchantDbaName || "Merchant"
						} is boarded to ARISE`,
					}),
				);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
						delay: 10000,
					}),
				);

				onError?.(error);
			},
		},
	);
};

export default useBoardAriseMerchantMutation;
